export default __webpack_public_path__ + "static/media/avatar-03.97dee038.png";